import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { type RootState } from '../../../stateManagement/store'

const baseQuery = fetchBaseQuery({
    baseUrl: `/api/v1`,
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState)?.auth?.tokens?.services?.weatherStations
        if (token) {
            headers.set('Authorization', `Bearer ${token}`)
        }
        return headers
    }
})

export const weatherStationsAPI = createApi({
    reducerPath: 'weatherStationsAPI',
    baseQuery,
    endpoints: builder => ({}),
})

export const weatherStationsAPIReducer = weatherStationsAPI.reducer
export const resetWeatherStationsAPI = weatherStationsAPI.util.resetApiState